import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var EventsIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20,5H4A2,2,0,0,0,2,7V17a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V7A2,2,0,0,0,20,5ZM4.5,8A.5.5,0,1,1,5,7.5.5.5,0,0,1,4.5,8Zm2,0A.5.5,0,1,1,7,7.5.5.5,0,0,1,6.5,8Zm2,0A.5.5,0,1,1,9,7.5.5.5,0,0,1,8.5,8ZM11,17V13H9l4-6v4h2Z"
}), 'EventsIcon');